<!-- <a style="cursor: pointer;" (click)="onClick()"> -->
<a style="cursor: pointer;" routerLink="formio/inbox">
    <i *ngIf="inboxItemsCount > 0; else alertsBadge" 
        class="topbar-icon mi mi-orb-envelope" 
        pBadge
        style="font-size: 2rem" 
        [value]="inboxItemsCount" 
        severity="danger">
    </i>
    <ng-template #alertsBadge>
        <i class="topbar-icon mi mi-orb-envelope"></i>
    </ng-template>
    <span class="topbar-item-name">Forms Inbox</span>
    <!-- <i class="topbar-icon pi pi-envelope" pBadge value="2" severity="danger"></i> -->
</a>